import {Focus, Lock, LockOpen, MonitorPlay} from "lucide-react";
import {Button} from "@/components/ui/button.tsx";
import {useEncounter} from "@/encounter/EncounterHooks.ts";
import {useTurn} from "@/encounter/turns/TurnHooks.ts";
import {useEncounterViewPort} from "@/encounter/viewport/EncounterViewPortHooks.ts";
import {usePlayerView} from "@/player/PlayerViewHooks.ts";

export function PlayerDisplayTool() {
    const encounter = useEncounter();
    const {display, displayEncounter, loading} = usePlayerView();
    const {playerViewPortLocked, togglePlayerViewPortLock, focusPlayerViewPort} = useEncounterViewPort();
    const isDisplayed = display.display === "encounter" && display.encounter.id === encounter.id;
    const status = !isDisplayed ? "Spielern anzeigen" : playerViewPortLocked
        ? "Spielerausschnitt entsperren" : "Spielerausschnitt sperren";
    const dotColor = loading ? "bg-muted-foreground" : !isDisplayed ? "bg-red-500"
        : playerViewPortLocked ? "bg-blue-500" : "bg-green-500";

    return <div role="group" aria-label="Spieleranzeige" className="flex shrink-0 items-center gap-1">
        {isDisplayed && playerViewPortLocked &&
            <Button type="button" size="icon" variant="ghost"
                    title="Ausschnitt anzeigen" aria-label="Ausschnitt anzeigen" onClick={focusPlayerViewPort}>
                <Focus/>
            </Button>}
        <Button type="button" size="icon" variant="ghost" className="relative" title={status}
                aria-label={status} aria-pressed={isDisplayed && playerViewPortLocked} disabled={loading}
                onClick={() => isDisplayed ? togglePlayerViewPortLock() : void displayEncounter(encounter)}>
            {isDisplayed ? playerViewPortLocked ? <Lock/> : <LockOpen/> : <MonitorPlay/>}
            <span aria-hidden="true"
                  className={`absolute right-0.5 top-0.5 size-2.5 rounded-full border border-card ${dotColor}`}/>
        </Button>
    </div>;
}

export function PlayerDisplayBanner() {
    const encounter = useEncounter();
    const {display, displayEncounter, loading, error} = usePlayerView();
    const {round} = useTurn();
    const isDisplayed = display.display === "encounter" && display.encounter.id === encounter.id;
    if (loading || isDisplayed) return null;

    return <div role="status" className={`pointer-events-auto absolute left-1/2 z-20 flex max-w-[calc(100%-1rem)]
        -translate-x-1/2 items-center gap-3 rounded-lg border border-destructive/50 bg-card/95 p-2 shadow-lg
        backdrop-blur-sm ${round > 0 ? "top-36" : "top-4"}`}>
        <span aria-hidden="true" className="size-2.5 shrink-0 rounded-full bg-red-500"/>
        <span className="min-w-0 text-sm font-medium">
            {error ? "Spieleranzeige konnte nicht aktualisiert werden." : "Dieser Encounter wird den Spielern nicht angezeigt."}
        </span>
        <Button type="button" size="sm" className="shrink-0" onClick={() => void displayEncounter(encounter)}>
            Anzeigen
        </Button>
    </div>;
}
